
/* Generated apis ---------------------- */
import { to } from 'react-lib/utils'
import BaseService from  'react-lib/apis/services/BaseService'
import config from '../../config/config'
import CentralLabOrderListForQueueSerializer from '../types/CentralLabOrderListForQueueSerializer_apps_LAB'


const HOST = `${config.API_HOST}`
/* ['generics.ListAPIView'] */
/* params: status, encounter, emr, 'start_date', 'end_date', 'patient', 'hn', 'first_name', 'last_name', 'encounter_type', 'order_div', 'order_by', 'lab_type', 'full_access_number', 'urgency', 'not_collect_specimen', 'specimen_rejected', 'is_appointment', 'exclude_blood_bank', 'only_blood_bank', 'only_collect_specimen', 'approve_status', 'sort', 'start_date_cross_match', 'end_date_cross_match', 'include_appointment', 'lab_speciality' */
/* data:  */
const CentralLabOrderSimplifiedList : 
{
  list:     ({params, apiToken, extra}:
             { 
                params?: any,
                apiToken?: any,
                extra?: any,
            }) => any,
} = 
{
  list: async ({params, apiToken, extra}) => {
    const base = new BaseService()
    if (apiToken)
      base.client.defaults.headers.common["Authorization"] = "Token " + apiToken;
    if (extra?.division)
      base.client.defaults.headers.common["division"] = extra.division;
    if (extra?.device)
      base.client.defaults.headers.common["device"] = extra.device;
    const result = await to(base.client.get(`${HOST}/apis/LAB/central-lab-order-simplified/`,
      { params: params ? { ...params } : {},
         ...extra
      }
    )
    .then(base.handleResponse)
    .catch(base.throwErrorMessage))
    return [result[1], result[0], result[2]]
  },
}

export default CentralLabOrderSimplifiedList

